import React from 'react';
import block from 'propmods';
import { Header } from '../Form/Form';

import './PageSegment.scss';

const b = block('PageSegment');

interface Props {
    title: string;
    available?: boolean;
    children: React.ReactNode;
    stubText: string;
    offsetTop?: boolean;
    offsetBottom?: boolean;
}

export const PageSegment: React.FC<Props> = ({
    title,
    available = true,
    children,
    stubText,
    offsetBottom,
    offsetTop,
}) => {
    return (
        <div {...b({ available, 'offset-top': offsetTop, 'offset-bottom': offsetBottom })}>
            <Header title={title} />
            {available ? children : stubText}
        </div>
    );
};
